/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUserInfo = /* GraphQL */ `
  query GetUserInfo($id: ID!) {
    getUserInfo(id: $id) {
      id
      userCognitoSub
      userFirst
      userLast
      email
      phone1
      phone2
      address1
      address2
      address3
      City
      state
      zip
      zip4
      country
      activeUser
      premiumUser
      regInitialized
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listUserInfos = /* GraphQL */ `
  query ListUserInfos(
    $filter: ModeluserInfoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserInfos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userCognitoSub
        userFirst
        userLast
        email
        phone1
        phone2
        address1
        address2
        address3
        City
        state
        zip
        zip4
        country
        activeUser
        premiumUser
        regInitialized
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getHeatingUnit = /* GraphQL */ `
  query GetHeatingUnit($id: ID!) {
    getHeatingUnit(id: $id) {
      id
      unitEmail
      unitPhone
      unitAddress1
      unitAddress2
      unitAddress3
      unitCity
      unitState
      unitZip
      unitZip4
      unitCountry
      unitCapacity
      usageFactor
      sumDegreeDays
      sumFeelsLikeDays
      hotWater
      estRemainingCapacity
      estRemainingPercentage
      huLastUpdate
      activeUnit
      autoOrder
      autoOrderVendor
      preferredVendor
      vendorOwned
      owningVendor
      userOwned
      owningUser
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listHeatingUnits = /* GraphQL */ `
  query ListHeatingUnits(
    $filter: ModelheatingUnitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHeatingUnits(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        unitEmail
        unitPhone
        unitAddress1
        unitAddress2
        unitAddress3
        unitCity
        unitState
        unitZip
        unitZip4
        unitCountry
        unitCapacity
        usageFactor
        sumDegreeDays
        sumFeelsLikeDays
        hotWater
        estRemainingCapacity
        estRemainingPercentage
        huLastUpdate
        activeUnit
        autoOrder
        autoOrderVendor
        preferredVendor
        vendorOwned
        owningVendor
        userOwned
        owningUser
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getOilVendor = /* GraphQL */ `
  query GetOilVendor($id: ID!) {
    getOilVendor(id: $id) {
      id
      vendorCognitoSub
      vendorFirst1
      vendorFirst2
      vendorLast1
      vendorLast2
      vendorEmail1
      vendorEmail2
      vendorPhone1
      vendorPhone2
      vendorAddress1
      vendorAddress2
      vendorAddress3
      vendorCity
      vendorState
      vendorZip
      vendorZip4
      unitCountry
      premiumVendor
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listOilVendors = /* GraphQL */ `
  query ListOilVendors(
    $filter: ModeloilVendorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOilVendors(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        vendorCognitoSub
        vendorFirst1
        vendorFirst2
        vendorLast1
        vendorLast2
        vendorEmail1
        vendorEmail2
        vendorPhone1
        vendorPhone2
        vendorAddress1
        vendorAddress2
        vendorAddress3
        vendorCity
        vendorState
        vendorZip
        vendorZip4
        unitCountry
        premiumVendor
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getCurrDegreeDays = /* GraphQL */ `
  query GetCurrDegreeDays($id: ID!) {
    getCurrDegreeDays(id: $id) {
      id
      currDate
      currTime
      currTemp
      currFeelsLike
      currDegreeDays
      currFeelsLikeDays
      currHWDegreeDays
      currHWFeelsLikeDays
      createdAt
      updatedAt
    }
  }
`;
export const listCurrDegreeDayss = /* GraphQL */ `
  query ListCurrDegreeDayss(
    $filter: ModelcurrDegreeDaysFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCurrDegreeDayss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        currDate
        currTime
        currTemp
        currFeelsLike
        currDegreeDays
        currFeelsLikeDays
        currHWDegreeDays
        currHWFeelsLikeDays
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getHistDegreeDays = /* GraphQL */ `
  query GetHistDegreeDays($id: ID!) {
    getHistDegreeDays(id: $id) {
      id
      histDate
      histLastUpdate
      histAvgTemp
      histAvgFeelsLike
      histAvgDegreeDays
      histAvgFeelsLikeDays
      histAvgHWDegreeDays
      histAvgHWFeelsLikeDays
      createdAt
      updatedAt
    }
  }
`;
export const listHistDegreeDayss = /* GraphQL */ `
  query ListHistDegreeDayss(
    $filter: ModelhistDegreeDaysFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHistDegreeDayss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        histDate
        histLastUpdate
        histAvgTemp
        histAvgFeelsLike
        histAvgDegreeDays
        histAvgFeelsLikeDays
        histAvgHWDegreeDays
        histAvgHWFeelsLikeDays
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getRefills = /* GraphQL */ `
  query GetRefills($id: ID!) {
    getRefills(id: $id) {
      id
      heatingUnitID
      refillDate
      fullRefill
      projectedVolume
      actualVolume
      volumeDiff
      accuracyRatio
      refillVendor
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listRefillss = /* GraphQL */ `
  query ListRefillss(
    $filter: ModelrefillsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRefillss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        heatingUnitID
        refillDate
        fullRefill
        projectedVolume
        actualVolume
        volumeDiff
        accuracyRatio
        refillVendor
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
